var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgListBullets1 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M8.5 5H23a1 1 0 1 0 0-2H8.5a1 1 0 0 0 0 2Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M23 11H8.5a1 1 0 0 0 0 2H23a1 1 0 0 0 0-2Z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M23 19H8.5a1 1 0 0 0 0 2H23a1 1 0 0 0 0-2Z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M1.5 2.5h2s.5 0 .5.5v2s0 .5-.5.5h-2S1 5.5 1 5V3s0-.5.5-.5Z"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  d: "M3.5 1.5h-2A1.5 1.5 0 0 0 0 3v2a1.5 1.5 0 0 0 1.5 1.5h2A1.5 1.5 0 0 0 5 5V3a1.5 1.5 0 0 0-1.5-1.5ZM4 5a.5.5 0 0 1-.5.5h-2A.5.5 0 0 1 1 5V3a.5.5 0 0 1 .5-.5h2A.5.5 0 0 1 4 3v2Z"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  d: "M1.5 10.5h2s.5 0 .5.5v2s0 .5-.5.5h-2s-.5 0-.5-.5v-2s0-.5.5-.5Z"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  d: "M3.5 9.5h-2A1.5 1.5 0 0 0 0 11v2a1.5 1.5 0 0 0 1.5 1.5h2A1.5 1.5 0 0 0 5 13v-2a1.5 1.5 0 0 0-1.5-1.5ZM4 13a.5.5 0 0 1-.5.5h-2A.5.5 0 0 1 1 13v-2a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 .5.5v2Z"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  d: "M1.5 18.5h2s.5 0 .5.5v2s0 .5-.5.5h-2s-.5 0-.5-.5v-2s0-.5.5-.5Z"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  d: "M3.5 17.5h-2A1.5 1.5 0 0 0 0 19v2a1.5 1.5 0 0 0 1.5 1.5h2A1.5 1.5 0 0 0 5 21v-2a1.5 1.5 0 0 0-1.5-1.5ZM4 21a.5.5 0 0 1-.5.5h-2A.5.5 0 0 1 1 21v-2a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 .5.5v2Z"
})));
export { SvgListBullets1 as ReactComponent };
export default __webpack_public_path__ + "a05ebafc10e13032859abe2a01455ee994d9651df881bd73ca7c3f51f1ec02ac.svg";